<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="订单ID" prop="orderId" >
        <a-input v-model="form.orderId" placeholder="请输入订单ID" />
      </a-form-model-item>
      <a-form-model-item label="箱长" prop="boxLength" >
        <a-input v-model="form.boxLength" placeholder="请输入箱长" />
      </a-form-model-item>
      <a-form-model-item label="箱宽" prop="boxWidth" >
        <a-input v-model="form.boxWidth" placeholder="请输入箱宽" />
      </a-form-model-item>
      <a-form-model-item label="箱高" prop="boxHeight" >
        <a-input v-model="form.boxHeight" placeholder="请输入箱高" />
      </a-form-model-item>
      <a-form-model-item label="箱子数量" prop="boxNum" >
        <a-input v-model="form.boxNum" placeholder="请输入箱子数量" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrderBox, addOrderBox, updateOrderBox } from '@/api/user/orderBox'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        orderId: null,

        boxLength: null,

        boxWidth: null,

        boxHeight: null,

        boxNum: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        boxLength: null,
        boxWidth: null,
        boxHeight: null,
        boxNum: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderBox({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrderBox(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrderBox(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
